// extracted by mini-css-extract-plugin
module.exports = {"centralize":"SearchBar_centralize__8SwOy","inputBlock":"SearchBar_inputBlock__1zEqU","placeholder":"SearchBar_placeholder__24_1P"};